const markerGroupGenerators = {
    romanize(cap: boolean): (count: number) => string {
        return function (num: number) {
            // Stolen from https://stackoverflow.com/a/9083076

            if (!+num) return NaN.toString();

            const digits = String(+num).split('');

            const key = [
                '',
                'C',
                'CC',
                'CCC',
                'CD',
                'D',
                'DC',
                'DCC',
                'DCCC',
                'CM',

                '',
                'X',
                'XX',
                'XXX',
                'XL',
                'L',
                'LX',
                'LXX',
                'LXXX',
                'XC',

                '',
                'I',
                'II',
                'III',
                'IV',
                'V',
                'VI',
                'VII',
                'VIII',
                'IX',
            ];

            let roman = '';

            let i = 3;

            while (i--) {
                const digit = `${digits.pop()}`;

                roman = (key[+digit + i * 10] || '') + roman;
            }

            const romanized = Array(+digits.join('') + 1).join('M') + roman;

            return cap ? romanized : romanized.toLowerCase();
        };
    },

    symbolRepeater(symbol: string): (count: number) => string {
        return function (count: number) {
            // Number of symbols generated is (last - 1). First marker
            // out will start with last === 2, thus generating one symbol.
            return Array(count + 1).join(symbol);
        };
    },

    seriesRepeater(series: string | string[]): (count: number) => string {
        return function (count: number) {
            const i = (count - 1) % series.length;
            const char = series[i];
            const repetitions = Math.floor((count - 1) / series.length) + 1;
            return Array(repetitions + 1).join(char);
        };
    },
};

export const markerGroups: { [groupId: string]: (count: number) => string } = {
    Numeric: (idx: number) => `${idx}`,
    Star: markerGroupGenerators.symbolRepeater('*'),
    Dagger: markerGroupGenerators.symbolRepeater('&dagger;'),
    Symbol: markerGroupGenerators.seriesRepeater([
        '\u2020',
        '\u2021',
        '\u2022',
        '\u00A7',
        '\u00B6',
        '\u2032',
        '\u2033',
        '\u2034',
        '\u203B',
        '\u2042',
        '\u2051',
        '\u2055',
        '\u2056',
        '\u2058',
        '\u2059',
        '\u205C',
    ]),
    Alpha: markerGroupGenerators.seriesRepeater('abcdefghijklmnopqrstuvwxyz'),
    AlphaCap: markerGroupGenerators.seriesRepeater('ABCDEFGHIJKLMNOPQRSTUVWXYZ'),
    Roman: markerGroupGenerators.romanize(false),
    RomanCap: markerGroupGenerators.romanize(true),
};
